import React, { useState, useEffect } from 'react';
import './App.css';
import { DialogQueue } from '@rmwc/dialog';
import '@rmwc/dialog/styles';
import track from 'tracker';
import Durchbiegung from './Durchbiegung/Durchbiegung';
import AppBar from './AppBar';
import Vorselektion from './Vorselektion/Vorselektion';
import MDruckpunkte from './MDruckpunkte/MDruckpunkte';
import Hilfe from './Hilfe';
import Sidebar from './Sidebar';
import { queue } from './myQueue';
import { useFlexionStore } from './Stores';

function App() {
  const setSprache = useFlexionStore((state) => state.setSprache);
  const [Methode, setMethode] = useState('H');
  const [printTitle, setPrintTitle] = useState('');
  const [triggerPrint, setTriggerPrint] = useState(false);

  useEffect(() => {
    track('Flexion');
    const lang = document.baseURI.substring(document.baseURI.length - 2, document.baseURI.length);
    setSprache(lang);
  }, [setSprache]);

  function setTitleandPrint(title) {
    if (title === '' || title === null) return;
    setPrintTitle(title);
    setTriggerPrint(true);
  }

  useEffect(() => {
    if (triggerPrint) {
      setTriggerPrint(false);
      window.print();
    }
  }, [triggerPrint]);

  function handleMethode() {
    switch (Methode) {
      case 'V':
        return <Vorselektion />;
      case 'M':
        return <MDruckpunkte />;
      case 'D':
        return <Durchbiegung />;
      case 'H':
        return <Hilfe onMethodeChange={(methode) => setMethode(methode)} />;
      default:
        return <Hilfe onMethodeChange={(methode) => setMethode(methode)} />;
    }
  }

  return (
    <>
      <div className='Title'>
        <h2>{printTitle}</h2>
      </div>
      <DialogQueue dialogs={queue.dialogs} />
      {Methode === 'H' ? (
        ''
      ) : (
        <AppBar
          className='AppBar'
          onMethodeChange={(methode) => setMethode(methode)}
          Methode={Methode}
          Print={setTitleandPrint}
        />
      )}
      <Sidebar Print={setTitleandPrint} />
      {handleMethode()}
    </>
  );
}

export default App;
